import React from 'react'
import { useSelector } from 'react-redux'
import { filterItemsByOrderStatus } from '../../utils/filter'
import { NoResults } from '../reusables/noResults'
import { LoadingScreen } from '../../loading/loading'
import { CANCELLED_FILTER } from '../../const'
import { Grid } from '@material-ui/core'
import { OrderCards } from '../orderCards/orderCards'
import { todaysDeliveriesTitleMap } from '../todaysDeliveries/todaysDeliveriesContent'

export const Cancelled = () => {
  const { todaysDeliveries, isLoading } = useSelector(state => state.today)
  const { language } = useSelector(state => state.auth)
  const cancelled = filterItemsByOrderStatus(todaysDeliveries.trips, CANCELLED_FILTER)

  return isLoading ? (
    <LoadingScreen />
  ) : (
    <Grid container alignItems="center" justify="center">
      {cancelled.length === 0 ? (
        <NoResults />
      ) : (
        <OrderCards data={cancelled} title={todaysDeliveriesTitleMap.cancelled[language]} orderBy={'updatedAt'} />
      )}
    </Grid>
  )
}
